import { useRemovePolicyFromGroupMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useRemovePolicyHandler( options?: any ) {
	const [ removePolicyFromGroup ] = useRemovePolicyFromGroupMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( policyId: number ) => {
		const result = await removePolicyFromGroup( { variables: { policyId } } )
		if ( result.data?.removePolicyFromGroup?.success ) {
			showSuccess( `removePolicyFromGroupSuccess${Date.now()}`, result.data?.removePolicyFromGroup?.message ?? 'Success removed policy from group!' )
		} else {
			showError( `removePolicyFromGroupError${Date.now()}`, result.data?.removePolicyFromGroup?.message ?? 'Sorry, an error occurred' )
		}
	}
}
